import { Component, OnInit } from '@angular/core';

import { FirebaseService } from 'src/app/service/firebase.service';
import { HostListener } from '@angular/core';

import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl } from '@angular/forms';

import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-sign',
  templateUrl: './sign.component.html',
  styleUrls: ['./sign.component.scss']
})
export class SignComponent implements OnInit {

  title = 'grandtravel';
  isSignedIn = false;
  fieldTextType = false;

  formSignIn = this.fb.group({

    email: ['', [Validators.required, Validators.minLength(3),]],
    password: ['', [Validators.required, Validators.minLength(3),]],
  });
  router: any;

  constructor(private fb: FormBuilder, public firebaseService: FirebaseService) { }

  ngOnInit(): void {
    
    if (localStorage.getItem('user') != null) {
      this.isSignedIn = true;
    } else {
      this.isSignedIn = false;
    }



  }

  async onSignup(email: string, password: string) {
    await this.firebaseService.signup(email, password)
    if (this.firebaseService.isLoggedIn) {
      this.isSignedIn = true;
    }
  }

  async onSignin(email: string, password: string) {
    await this.firebaseService.signin(email, password)
    if (this.firebaseService.isLoggedIn) {
      this.isSignedIn = true;
      console.log(email);
    }

  }

  handleLogout() {
    this.isSignedIn = false;
  }


  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }


  @HostListener("window:scroll", []) onWindowScroll() {
    this.scrollFunction();
  }
  // When the user scrolls down 20px from the top of the document, show the button
  scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      document.getElementById("myBtn")!.style.display = "block";
    } else {
      document.getElementById("myBtn")!.style.display = "none";
    }
  }

  // When the user clicks on the button, scroll to Service
  toAttr() {
    document.getElementById('toAttr')?.scrollIntoView({ behavior: 'smooth' })

  }


  // When the user clicks on the button, scroll to About
  toTrans() {
    document.getElementById('toTrans')?.scrollIntoView({ behavior: 'smooth' })

  }

  // When the user clicks on the button, scroll to About
  toPort() {
    document.getElementById('toPort')?.scrollIntoView({ behavior: 'smooth' })

  }


  // When the user clicks on the button, scroll to About
  toTeam() {
    document.getElementById('toTeam')?.scrollIntoView({ behavior: 'smooth' })

  }

  // When the user clicks on the button, scroll to About
  toContact() {
    document.getElementById('toContact')?.scrollIntoView({ behavior: 'smooth' })

  }

  // When the user clicks on the button, scroll to the top of the document
  topFunction() {
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' })
    // document.body.scrollTop = 0; // For Safari
    // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  sign: number = 0;

  signIn() {
    this.sign = 1
  }

  signUp() {
    this.sign = 0;
  }
}
